import { BaseColumnFormatter, StringFormatterSizeType, TableColumnInfo, TableRowInfo } from "namirasoft-site-react";

export class StorageUserNameFormatter extends BaseColumnFormatter
{
    constructor(width: string = StringFormatterSizeType.FullName)
    {
        super();
        this.width = width;
    }

    override format(value: any, _column: TableColumnInfo, row: TableRowInfo<any>, _printable: boolean): any
    {
        const raw = (value ?? "").toString();
        const user_id: string = row?.value?.user_id ?? "";
        if (!user_id)
            return raw;
        const prefix = `${user_id}-`;
        return (
            <span>
                <span style={{ color: "#8e8e8e" }}>{prefix}</span>
                <span>{raw}</span>
            </span>
        );
    }

    override compare(a: any, b: any): number
    {
        return BaseColumnFormatter.stringCompare(a, b);
    }
}